export const shouldLoad = () => document.querySelector('[data-controller="pagination"]') !== undefined;
